import { render, staticRenderFns } from "./Cellosign.vue?vue&type=template&id=2a54daaa"
import script from "./Cellosign.vue?vue&type=script&lang=js"
export * from "./Cellosign.vue?vue&type=script&lang=js"
import style0 from "./Cellosign.vue?vue&type=style&index=0&id=2a54daaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports